import request from '@/utils/request'

// 获取角色列表
export function getRoleList(data) {
  return request({
    url: '/admin/role/list',
    method: 'post',
    data: data
  })
}
// 更新角色
export function UpdataRole(data) {
  return request({
    url: '/admin/role/update',
    method: 'post',
    data: data
  })
}
// 新增角色
export function addRole(data) {
  return request({
    url: '/admin/role/save',
    method: 'post',
    data: data
  })
}
// 删除角色
export function DelRole(data) {
  return request({
    url: '/admin/role/delete',
    method: 'post',
    data: data
  })
}
